<script>
import MetisMenu from "metismenujs/dist/metismenujs";
import { authComputed } from "@/state/helpers";
import { menuItems } from "./menu";
import store from "@/state/store";

const user = store.state.auth.user;
/**
 * Sidenav component
 */
const AdminUsers = ["super_admin", "pbx_admin_staff"];
export default {
  data() {
    return {
      menuItems: menuItems.filter((item) =>
        item.isForPhilippines
          ? item
          : user
          ? !AdminUsers.includes(user.user.user_type)
            ? user.user.iot_app_setting.is_access_web_app == false
              ? item.id !== 71
              : item
            : item
          : item
      ),
      menuData: null,
    };
  },
  computed: {
    ...authComputed,
  },
  mounted: function () {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu");
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    const paths = [];

    for (var i = 0; i < links.length; i++) {
      paths.push(links[i]["pathname"]);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf("/");
      const item = window.location.pathname.substr(0, strIndex).toString();
      matchingMenuItem = links[paths.indexOf(item)];
    } else {
      matchingMenuItem = links[itemIndex];
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4 && parent4.id !== "side-menu") {
              parent4.classList.add("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5 && parent5.id !== "side-menu") {
                parent5.classList.add("mm-active");
                const childanchor = parent5.querySelector(".is-parent");
                if (childanchor && parent5.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
    if (
      String(this.user.user.email).toLowerCase() == "philippine.admin@gmail.com"
    ) {
      this.menuItems = this.menuItems.filter((item) => item.isForPhilippines);
      return;
    }
    if (this.hotel == null && !AdminUsers.includes(this.user.user.user_type)) {
      this.menuItems = this.menuItems.filter((item) => item.isShowWithoutHotel);
    }
    let current_project_type = "";
    if (this.user.user.user_type == "super_admin") {
      current_project_type =
        localStorage.getItem("current_project_type") != null
          ? localStorage.getItem("current_project_type")
          : "all";
    } else {
      current_project_type =
        localStorage.getItem("current_project_type") != null
          ? localStorage.getItem("current_project_type")
          : "all";
    }

    if (this.user.user.user_type == "super_admin") {
      if (current_project_type == "all") {
        this.menuItems = this.menuItems.filter(
          (item) => item.isShow !== undefined
        );
      } else {
        this.menuItems = this.menuItems.filter((item) =>
          item.isShow !== undefined && item.includeProjectType != undefined
            ? item.includeProjectType.includes(current_project_type)
            : ""
        );
      }
    } else {
      if (this.user.user.user_type == "pbx_admin_staff") {
        if (current_project_type == "all") {
          this.menuItems = this.menuItems.filter((item) => item.isDomainUser);
        } else {
          this.menuItems = this.menuItems.filter((item) =>
            item.isDomainUser && item.includeProjectType != undefined
              ? item.includeProjectType.includes(current_project_type)
              : ""
          );
        }
      } else {
        if (this.hotel !== null) {
          if (current_project_type == "all") {
            this.menuItems = this.menuItems.filter(
              (item) => item.isShow == undefined && !item.isShowWithoutHotel
            );
          } else {
            this.menuItems = this.menuItems.filter((item) =>
              item.isShow == undefined &&
              !item.isShowWithoutHotel &&
              item.includeProjectType != undefined
                ? item.includeProjectType.includes(current_project_type)
                : ""
            );
          }
        }
      }
    }
  },

  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },

    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle("mm-show");
    },
    routePush(link) {
      if (link !== undefined && this.$route.path !== link) {
        this.$router.push(link);
      }
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <template v-for="item in menuItems">
        <li class="menu-title" v-if="item.isTitle" :key="item.id">
          {{ item.label }}
        </li>
        <li v-if="!item.isTitle && !item.isLayout" :key="item.id">
          <a
            v-if="hasItems(item)"
            href="javascript:void(0);"
            class="is-parent"
            :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
            @click="routePush(item.link)"
          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ item.label }}</span>
            <span
              :class="`badge rounded-pill bg-${item.badge.variant} float-end`"
              v-if="item.badge"
              >{{ item.badge.text }}</span
            >
          </a>

          <router-link
            :to="item.link"
            v-if="!hasItems(item)"
            class="side-nav-link-ref"
          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ item.label }}</span>
            <span
              :class="`badge rounded-pill bg-${item.badge.variant} float-end`"
              v-if="item.badge"
              >{{ item.badge.text }}</span
            >
          </router-link>

          <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
            <li v-for="(subitem, index) of item.subItems" :key="index">
              <router-link
                :to="subitem.link"
                v-if="!hasItems(subitem)"
                class="side-nav-link-ref"
                >{{ subitem.label }}</router-link
              >
              <a
                v-if="hasItems(subitem)"
                class="side-nav-link-a-ref has-arrow"
                href="javascript:void(0);"
                >{{ subitem.label }}</a
              >
              <ul
                v-if="hasItems(subitem)"
                class="sub-menu mm-collapse"
                aria-expanded="false"
              >
                <li
                  v-for="(subSubitem, index) of subitem.subItems"
                  :key="index"
                >
                  <router-link
                    :to="subSubitem.link"
                    class="side-nav-link-ref"
                    >{{ subSubitem.label }}</router-link
                  >
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </template>
    </ul>
  </div>
  <!-- Sidebar -->
</template>
